<template>
  <div class="m-4 border border rounded-xl overflow-hidden">
    <!-- Header -->
    <div class="px-3 py-2 font-semibold text-lg bg-gray-50 border-b">General Settings</div>

    <!-- loader -->
    <div v-if="loading" v-loading="loading" style="height: 100px"></div>

    <div v-else>
      <!-- Setting: Bit map at bottom -->
      <div class="justify-center p-3 ">
        <el-switch
          v-model="settings.putBitmapAtBottom.value"
          class="ml-2"
          @click="savePixelTracingPositionSetting()"
          style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
        />
        <span class="pl-2">Put email open tracing pixel image at bottom</span>
        <div class="text-sm text-gray-600 pt-0 pl-14">
          If enabled the image tracking pixel will be put at the bottom of body tag, if disabled it will be placed at the top.
        </div>
      </div>

    </div>
  </div>

  <div class="m-4 border border rounded-xl overflow-hidden">
    <div class="px-3 py-2 font-semibold text-lg bg-gray-50 border-b">Revenue Tracking</div>

    <div v-if="loading" v-loading="loading" style="height: 100px"></div>

    <div v-else class="p-3">
      <div class="text-sm text-gray-600">
        Select the event and numeric attribute used to calculate campaign revenue.
      </div>

      <div v-if="isRevenueTrackingConfigured" class="mt-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <div class="text-sm font-medium text-gray-700">Revenue Event</div>
            <div class="mt-1 px-3 py-2 border rounded bg-gray-50 text-gray-700">
              {{ revenueEventInfo.event }}
            </div>
          </div>

          <div>
            <div class="text-sm font-medium text-gray-700">Revenue Attribute</div>
            <div class="mt-1 px-3 py-2 border rounded bg-gray-50 text-gray-700">
              {{ revenueEventInfo.property }}
            </div>
          </div>
        </div>

        <div class="text-sm text-gray-600 mt-4">
          Revenue tracking has already been configured and cannot be changed.
        </div>
      </div>

      <template v-else>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <label class="text-sm font-medium text-gray-700">Revenue Event</label>
          <el-select
            v-model="revenueEventInfo.event"
            filterable
            class="w-full mt-1"
            placeholder="Select revenue event"
            @change="onRevenueEventSelect()"
          >
            <el-option v-for="event in revenueEventList" :key="event" :label="event" :value="event" />
          </el-select>
        </div>

        <div>
          <label class="text-sm font-medium text-gray-700">Revenue Attribute</label>
          <el-select
            v-model="revenueEventInfo.property"
            filterable
            class="w-full mt-1"
            placeholder="Select revenue attribute"
            :disabled="!revenueEventInfo.event"
          >
            <el-option
              v-for="property in revenuePropertyList"
              :key="property.name"
              :label="property.name"
              :value="property.name"
              :disabled="property.type !== 'number'"
            />
          </el-select>
        </div>
      </div>

      <div class="mt-4">
        <el-button type="primary" size="small" :loading="savingRevenueSettings" @click="saveRevenueTrackingSettings">
          Save Revenue Tracking
        </el-button>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import CustomDomainComponent from './GeneralCampaignSettings'
export default CustomDomainComponent
</script>
